import React from 'react'
import Box from '@material-ui/core/Box'
import LinearProgress from '@material-ui/core/LinearProgress'
import { PageHeader } from 'components/page-header'
import ApolloDataView from 'components/apollo-data-view'
import { useGetCoachAccount, useUpdateCoachAccount } from './api-hooks'
import { UnsavedChangesPrompt } from 'components/form-util'
import { useAccountForm } from './use-account-form'
import { ProfileCard, ContactPreferencesCard } from './account-form'
import MembershipDetails from './membership-details'
import LegalPolicies from './legal-policies'
import { useSnackbar } from 'notistack'
import SubscriptionDetails from './subscription-details'
import useAccountDetailsStyles from './styles'

const AccountDetails = ({ coach, updateCoachAccount, updating }) => {
  const classes = useAccountDetailsStyles()
  const { form } = useAccountForm(coach)
  const { enqueueSnackbar } = useSnackbar()

  const { handleSubmit, formState, errors } = form
  const hasErrors = Object.keys(errors).length > 0

  const handleUpdate = async ({ coachId, ...input }) => {
    try {
      const { data, error } = await updateCoachAccount({
        coachId,
        input: {
          ...input,
          phone: input.phone.replace(/-/g, ''),
        },
      })
      if (data?.success) {
        enqueueSnackbar('Update successful', { variant: 'success' })
        form.reset({ ...data.coach })
      } else {
        enqueueSnackbar(error?.message || 'Error updating account', {
          variant: 'error',
        })
      }
    } catch (e) {
      enqueueSnackbar(e.message, { variant: 'error' })
    }
  }

  return (
    <>
      <Box className={classes.contentContainer}>
        <Box className={classes.stack}>
          <SubscriptionDetails />
          <ProfileCard
            form={form}
            coach={coach}
            classes={classes}
            hasErrors={hasErrors}
            updating={updating}
            onSave={handleSubmit(handleUpdate)}
            saveDisabled={!formState.isDirty}
          />
          <ContactPreferencesCard
            form={form}
            classes={classes}
            hasErrors={hasErrors}
            updating={updating}
            onSave={handleSubmit(handleUpdate)}
            saveDisabled={!formState.isDirty}
          />
          <MembershipDetails classes={classes} />
          <LegalPolicies classes={classes} />
        </Box>
      </Box>
      <UnsavedChangesPrompt hasChanges={formState.isDirty} />
    </>
  )
}

export const AccountDetailsWrapper = () => {
  const { data, loading, error } = useGetCoachAccount()

  const [updateCoachAccount, { loading: updating }] = useUpdateCoachAccount()

  return (
    <>
      <PageHeader title="Account Details" />
      <ApolloDataView {...{ data, error, loading }}>
        {{
          errorView: <div>Error Loading Coach Data</div>,
          emptyView: <div>Test Loading Coach Data</div>,
          loadingView: <LinearProgress color="primary" />,
          dataView: coach => (
            <AccountDetails
              coach={coach}
              updateCoachAccount={updateCoachAccount}
              updating={updating}
            />
          ),
        }}
      </ApolloDataView>
    </>
  )
}
